import React from 'react';
import './BookEyeTest.scss';
import { useSelector } from 'react-redux';
import { triggerDataLayerOnCtaClick } from '../../../../own-days/helper';

const BookEyeTest = () => {
  const bookEyeTest = useSelector(state => state?.header?.mainNavigationData?.bookEyeTest);

  if (bookEyeTest) {
    return (
      <a
        className="odBookEyeTest"
        href={bookEyeTest.link}
        onClick={() => triggerDataLayerOnCtaClick(bookEyeTest.title)}
      >
        {bookEyeTest.title}
      </a>
    );
  }

  return null;
};

export default BookEyeTest;
